import { UnreadBadge } from "../common/UnreadBadge/UnreadBadge"
import { useUnreadCount } from "../hooks/useUnreadCount"
import styles from "./MobileMenuUnreadBadge.module.scss"
import type { ConversationListData, DMUnreadData } from "../types"

type Props = {
    dmUnreadData: DMUnreadData
    conversationListData: ConversationListData
}

export function MobileMenuUnreadBadge({
    dmUnreadData,
    conversationListData,
}: Props) {
    const { unreadCount } = useUnreadCount({
        dmUnreadData,
        conversationListData,
    })

    return (
        <div className={styles.container}>
            <UnreadBadge count={unreadCount} />
        </div>
    )
}
